import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavContainer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';

@Component({
  selector: 'app-visit-control',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './visit-control.component.html',
  styleUrl: './visit-control.component.scss'
})
export class VisitControlComponent {
  displayedColumns: string[] = [
    "routeCode",
    "userCode",
    "nameDate",
    "executionDate",
    "totalVisit",
    "totalOnRoute",
    "totalMissed",
    "totalSale",
    "ofVisit"
  ];

  dataSource = new MatTableDataSource<any[]>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex = 1
  sortActive = null
  sortDirection = 'asc'

  filter = {
    dateini: new Date(),
    dateend: new Date()
  }

  constructor(
  ) { }

  onFilter(){
  }

  onClearFilter(){

    this.onFilter()
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getListReport()
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.getListReport()
  }

  changePage(e) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getListReport()
  }

  getListReport(){

  }
}
